import { atom } from 'nanostores'

import type { InitData } from '@/services/schemas'

export const $data = atom<InitData | null>(null)
